import React, { useEffect, useCallback } from 'react'
import { responseDetailTenyuryoku } from 'types/ResponseTypes'
import { tenyuryokuTableDetail } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
import * as TableAction from 'actions/TableActions/TableTenyuryokuAction'
import { organismLog } from 'utils/logUtil'
import { useDispatch, useSelector } from 'react-redux'
import { fixPrice } from 'utils/stringUtil'

const width = tenyuryokuTableDetail.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

type Props = {
  detail: responseDetailTenyuryoku
  isChecked: boolean
  HININ_RIYU: string
  no: number
}

const O_TableRowTeenyuryoku = ({ detail, isChecked, HININ_RIYU, no }: Props) => {
  useEffect(() => organismLog('O_TableRowTeenyuryokuDetail'))
  const dispatch = useDispatch()
  const userKind = useSelector((state) => state.LoginReducer.userKind)
  const isJocho = useSelector((state) => state.LoginReducer.isJocho)

  // NET入力のとき
  const isNet = detail.SIIRE_TANKA !== 0 && detail.KURAIRI_NET !== 0 && detail.KOJIN_NET !== 0
  // 商品条件のとき
  const isShohin = !isNet && detail.JP_CD !== 0

  // チェック処理 //================================//
  const handleRowClick = useCallback((isChecked: boolean, detail: responseDetailTenyuryoku) => {
    dispatch(
      TableAction.checkDetail(isChecked, {
        isChecked: !isChecked,
        JOTAI_KBN: detail.JOTAI_KBN,
        KAKUNIN_KBN: detail.KAKUNIN_KBN,
        GYO_NO: detail.GYO_NO,
        HININ_RIYU: detail.HININ_RIYU,
        JOCHO_HININ_RIYU: detail.JOCHO_HININ_RIYU,
      }),
    )
  }, [])

  // 否認理由入力処理 //================================//
  const inputHininRiyu = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault()
      dispatch(
        TableAction.changeHininRiyu({
          isChecked: true,
          JOTAI_KBN: detail.JOTAI_KBN,
          KAKUNIN_KBN: detail.KAKUNIN_KBN,
          GYO_NO: detail.GYO_NO,
          HININ_RIYU: e.target.value,
          JOCHO_HININ_RIYU: detail.JOCHO_HININ_RIYU,
        }),
      )
    },
    [HININ_RIYU],
  )

  // 上長否認理由入力処理 //================================//
  const inputJochoHininRiyu = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault()
      dispatch(
        TableAction.changeJochoHininRiyu({
          isChecked: true,
          JOTAI_KBN: detail.JOTAI_KBN,
          KAKUNIN_KBN: detail.KAKUNIN_KBN,
          GYO_NO: detail.GYO_NO,
          HININ_RIYU: detail.JOCHO_HININ_RIYU,
          JOCHO_HININ_RIYU: e.target.value,
        }),
      )
    },
    [HININ_RIYU],
  )

  return (
    <>
      {/* No */}
      <M_TableCell category="number" data={no} width={width.NO} />
      {/* チェックボックス */}
      <M_TableCell category="checkbox" isChecked={isChecked} width={width.CHECK} click={() => handleRowClick(isChecked, detail)} />
      {/* 状態 */}
      <M_TableCell
        category="data" //
        width={width.JOTAI}
        align={'left'}
        title={detail.JOTAI}
        data={detail.JOTAI}
      />
      {
        /* 上長承認状態 */
        userKind === 0 ? (
          <M_TableCell
            category="data" //
            width={width.JOCHO_JOTAI}
            align={'left'}
            title={!isJocho && detail.JOCHO_KBN === 2 ? detail.JOCHO_HININ_RIYU : detail.JOCHO_JOTAI}
            data={detail.JOCHO_JOTAI}
          />
        ) : (
          <></>
        )
      }
      {/* 得意先コード */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_CD}
        align={'left'}
        title={detail.TOKUI_CD}
        data={detail.TOKUI_CD}
        blackout={manualMode}
      />
      {/* 得意先名 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_NM}
        align={'left'}
        title={detail.TOKUI_NM}
        data={detail.TOKUI_NM}
        blackout={manualMode}
      />
      {/* 部門コード */}
      {
        /* 部門コード */
        userKind === 0 ? (
          <M_TableCell
            category="data" //
            width={width.BUMON_CD}
            align={'left'}
            title={detail.BUMON_CD}
            data={detail.BUMON_CD}
            blackout={manualMode}
          />
        ) : (
          <></>
        )
      }
      {/* 部門名 */}
      {
        /* 部門名 */
        userKind === 0 ? (
          <M_TableCell
            category="data" //
            width={width.BUMON_NM}
            align={'left'}
            title={detail.BUMON_NM}
            data={detail.BUMON_NM}
            blackout={manualMode}
          />
        ) : (
          <></>
        )
      }
      {/* JANコード */}
      <M_TableCell
        category="data" //
        width={width.JAN_CD}
        align={'left'}
        title={isNet || isShohin ? detail.JAN_CD : ''}
        data={isNet || isShohin ? detail.JAN_CD : ''}
        blackout={manualMode}
      />
      {/* 品名規格 */}
      <M_TableCell
        category="data" //
        width={width.SHOHIN_KIKAKU}
        align={'left'}
        title={isNet || isShohin ? detail.SHOHIN_KIKAKU : ''}
        data={isNet || isShohin ? detail.SHOHIN_KIKAKU : ''}
        blackout={manualMode}
      />
      {/* 合計金額 */}
      <M_TableCell
        category="data" //
        width={width.SEISAN_GK}
        align={'right'}
        title={fixPrice(detail.SEISAN_GK)}
        data={fixPrice(detail.SEISAN_GK)}
        blackout={manualMode}
      />
      {/* 数量 */}
      <M_TableCell
        category="data" //
        width={width.SEISAN_SU}
        align={'right'}
        title={fixPrice(detail.SEISAN_SU)}
        data={fixPrice(detail.SEISAN_SU)}
        blackout={manualMode}
      />
      {/* 仕入単価 */}
      <M_TableCell
        category="data" //
        width={width.SIIRE_TANKA}
        align={'right'}
        title={isNet ? fixPrice(detail.SIIRE_TANKA) : ''}
        data={isNet ? fixPrice(detail.SIIRE_TANKA) : ''}
        blackout={manualMode}
      />
      {/* 倉入NET */}
      <M_TableCell
        category="data" //
        width={width.KURAIRI_NET}
        align={'right'}
        title={isNet ? fixPrice(detail.KURAIRI_NET) : ''}
        data={isNet ? fixPrice(detail.KURAIRI_NET) : ''}
        blackout={manualMode}
      />
      {/* 個人NET */}
      <M_TableCell
        category="data" //
        width={width.KOJIN_NET}
        align={'right'}
        title={isNet ? fixPrice(detail.KOJIN_NET) : ''}
        data={isNet ? fixPrice(detail.KOJIN_NET) : ''}
        blackout={manualMode}
      />
      {/* 単価 */}
      <M_TableCell
        category="data" //
        width={width.SEISAN_TANKA}
        align={'right'}
        title={fixPrice(detail.SEISAN_TANKA)}
        data={fixPrice(detail.SEISAN_TANKA)}
        blackout={manualMode}
      />
      {
        /* 否認理由・上長否認理由 */
        isJocho ? (
          <M_TableCell
            category="form" //
            width={width.JOCHO_HININ_RIYU}
            align={'left'}
            title={HININ_RIYU}
            data={HININ_RIYU}
            change={inputJochoHininRiyu}
            disabled={!isChecked}
            blackout={manualMode}
          />
        ) : (
          <M_TableCell
            category="form" //
            width={width.HININ_RIYU}
            align={'left'}
            title={HININ_RIYU}
            data={HININ_RIYU}
            change={inputHininRiyu}
            disabled={userKind === 0 ? true : !isChecked}
            blackout={manualMode}
          />
        )
      }
    </>
  )
}

export default React.memo(O_TableRowTeenyuryoku)
